import Vue from 'vue';
import $web3js from '../web3.js';
import $bizConfig from '@/models/bizConfig.js';
import $utils from "@/lib/utils/index.js";

const erc721Contract = require('./erc721Contract.json')

let web3 = $web3js.getWeb3();
let contractMap = new Map();
let tokenMap = new Map();
let tokenBySymbolMap = new Map();

const handleContractEmpty = (_defaultValue) => {
    return new Promise((resolve, reject) => {
        resolve(_defaultValue);
    })
}

const getErc721Abi = (funcName) => {
    let arrs = erc721Contract.abi.filter((value, key, values) => {
        return funcName === value.name
    })
    return arrs && arrs.length > 0 ? arrs[0] : null;
}

const getErc721Contract = (_contractAddress) => {
    let _erc721Contract = contractMap.get(_contractAddress.toUpperCase());
    if (!_erc721Contract) {
        try {
            _erc721Contract = web3 ? new web3.eth.Contract(erc721Contract.abi, _contractAddress) : '';
        } catch (error) {
            Vue.prototype.$toast(error && error.message ? error.message : error);
        }
        if (!!_erc721Contract) {
            contractMap.set(_contractAddress.toUpperCase(), _erc721Contract)
        }
    }
    return _erc721Contract;
}

const getErc721Balance = ([_contractAddress, owner], options) => {
    let contract = getErc721Contract(_contractAddress);
    if (!contract) {
        return handleContractEmpty("");
    }
    return $web3js.call(contract.methods.balanceOf, [owner], options);
}

const getErc721BalanceCall = ([_contractAddress, _owner]) => {
    return [_contractAddress, $web3js.encodeFunctionCall(getErc721Abi('balanceOf'), [_owner])];
}

const getErc721OwnerOf = ([_contractAddress, tokenId], options) => {
    let contract = getErc721Contract(_contractAddress);
    if (!contract) {
        return handleContractEmpty("");
    }
    return $web3js.call(contract.methods.ownerOf, [tokenId], options);
}

const getErc721OwnerOfCall = ([_contractAddress, tokenId]) => {
    return [_contractAddress, $web3js.encodeFunctionCall(getErc721Abi('ownerOf'), [tokenId])];
}




const getErc721tokenURICall = ([_contractAddress, tokenId], options) => {
    let contract = getErc721Contract(_contractAddress);
    if (!contract) {
        return handleContractEmpty("");
    }
    return $web3js.call(contract.methods.tokenURI, [tokenId], options);
}

const getErc721TokensOfOwner = ([_contractAddress, owner], options) => {
    let contract = getErc721Contract(_contractAddress);
    if (!contract) {
        return handleContractEmpty("");
    }
    return $web3js.call(contract.methods.tokensOfOwner, [owner], options);
}

const getErc721TokensOfOwnerCall = ([_contractAddress, owner]) => {
    return [_contractAddress, $web3js.encodeFunctionCall(getErc721Abi('tokensOfOwner'), [owner])];
}

const getErc721TokenByIndex = ([_contractAddress, index], options) => {
    let contract = getErc721Contract(_contractAddress);
    if (!contract) {
        return handleContractEmpty("");
    }
    return $web3js.call(contract.methods.tokenByIndex, [index]);
}

const getErc721TokenByIndexCall = ([_contractAddress, index]) => {
    return [_contractAddress, $web3js.encodeFunctionCall(getErc721Abi('tokenByIndex'), [index])];
}

const getErc721TokenOfOwnerByIndex = ([_contractAddress, owner, index], options) => {
    let contract = getErc721Contract(_contractAddress);
    if (!contract) {
        return handleContractEmpty("");
    }
    return $web3js.call(contract.methods.tokenOfOwnerByIndex, [owner, index], options);
}

const getErc721TokenOfOwnerByIndexCall = ([_contractAddress, owner, index]) => {
    return [_contractAddress, $web3js.encodeFunctionCall(getErc721Abi('tokenOfOwnerByIndex'), [owner, index])];
}

const getErc721IsApprovedForAll = ([_contractAddress, owner, operator], options) => {
    let contract = getErc721Contract(_contractAddress);
    if (!contract) {
        return handleContractEmpty("");
    }
    return $web3js.call(contract.methods.isApprovedForAll, [owner, operator], options);
}

const getErc721IsApprovedForAllCall = ([_contractAddress, owner, operator]) => {
    return [_contractAddress, $web3js.encodeFunctionCall(getErc721Abi('isApprovedForAll'), [owner, operator])];
}

const getErc721SymbolCall = ([_contractAddress]) => {
    return [_contractAddress, $web3js.encodeFunctionCall(getErc721Abi('symbol'), [])];
}

const getErc721TotalSupplyCall = ([_contractAddress]) => {
    return [_contractAddress, $web3js.encodeFunctionCall(getErc721Abi('totalSupply'), [])];
}

const erc721SetApprovalForAll = ([_contractAddress, operator, _approved], options, callback) => {
    let contract = getErc721Contract(_contractAddress);
    if (!contract) {
        return handleContractEmpty("");
    }
    return $web3js.send(contract.methods.setApprovalForAll, [operator, _approved], options, callback);
}

const erc721SetApprovalForAllEstimateSend = async([_contractAddress, operator, _approved], options) => {
    let contract = getErc721Contract(_contractAddress);
    if (!contract) {
        return handleContractEmpty("");
    }
    let gasPromise = $web3js.estimateSend(contract.methods.setApprovalForAll, [operator, _approved], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

const erc721transferFrom = ([_contractAddress, from, to, tokenId], options, callback) => {
    let contract = getErc721Contract(_contractAddress);
    if (!contract) {
        return handleContractEmpty("");
    }
    return $web3js.send(contract.methods.transferFrom, [from, to, tokenId], options, callback);
}

const erc721transferFromEstimateSend = async([_contractAddress, from, to, tokenId], options) => {
    let contract = getErc721Contract(_contractAddress);
    if (!contract) {
        return handleContractEmpty("");
    }
    let gasPromise = $web3js.estimateSend(contract.methods.transferFrom, [from, to, tokenId], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

// Biz

const initErc721Map = () => {
    if (tokenMap.size == 0) {
        let _tokens = $bizConfig.erc721List
        if (_tokens.length > 0) {
            _tokens.forEach((_token) => {
                tokenMap.set(_token.address.toUpperCase(), _token);
                tokenBySymbolMap.set(_token.symbol.toUpperCase(), _token);
            })
        }
    }
}

const getErc721Info = (address) => {
    if (!address) {
        return undefined;
    }
    return tokenMap.get(address.toUpperCase());
}

const getErc721Address = (symbol) => {
    if (!symbol) {
        return undefined;
    }
    let _token = tokenBySymbolMap.get(symbol.toUpperCase())
    return !!_token ? _token.address : undefined;
}

initErc721Map();

export default {
    getErc721Abi,
    getErc721Contract,
    getErc721Balance,
    getErc721BalanceCall,
    getErc721OwnerOf,
    getErc721OwnerOfCall,
    getErc721TokensOfOwner,
    getErc721TokensOfOwnerCall,
    getErc721TokenByIndex,
    getErc721TokenByIndexCall,
    getErc721TokenOfOwnerByIndex,
    getErc721TokenOfOwnerByIndexCall,
    getErc721SymbolCall,
    getErc721TotalSupplyCall,
    getErc721IsApprovedForAll,
    getErc721IsApprovedForAllCall,
    erc721SetApprovalForAll,
    erc721SetApprovalForAllEstimateSend,
    erc721transferFrom,
    erc721transferFromEstimateSend,
    getErc721Info,
    getErc721Address,
    getErc721tokenURICall
}



// WEBPACK FOOTER //
// ./src/lib/contract/erc721/index.js